import React, { useState } from 'react';
import useApi from '../hooks/useApi';
import posthog from 'posthog-js';

export default function LoginPage({onShowSignUp,authenticated}) {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const { request } = useApi();


  const profileDetails = async () => {
    try {
      const data = await request({
        method: 'get',
        url: `/api/v1/users/profile/`,
        withAuth:true,
      });
      localStorage.setItem('user_id', data.user_id);
      localStorage.setItem('name', data.first_name);
      localStorage.setItem('email', data.email);
      localStorage.setItem('is_premium', data.is_premium);
      setMessage('Login successful!');
      posthog.capture('login_success', {
        email: email,
        user_id: data.user_id,
        name: data.first_name
      });
      posthog.identify(data.user_id, {
        email: email,
        name: data.first_name
      });
      authenticated();
    } catch (err) {
      if (err?.response?.data?.detail) {
        setMessage(err.response.data.detail);
      } else {
        setMessage('Something went wrong. Try again later.');
      }
      console.error('API Error:', err);
    }finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    setMessage('');
    if (email === ''){
      setMessage("Please enter Email!");
      return;
    }
    if (password === ''){
      setMessage("Please enter Password!");
      return;
    }
    if (password.length < 8){
      setMessage("Password must not be less than 8 characters!");
      return;
    }
    setLoading(true);
    posthog.capture('login_attempt', {
      email_entered: email,
      email_length: email.length,
      password_length: password.length
    });
    try {
      const res = await request({
        method: 'post',
        url: 'api/v1/users/login/',
        data: {
          email: email,
          password: password
        }
      });
      if (res?.access && res?.refresh) {
        localStorage.setItem('access_token', res.access);
        localStorage.setItem('refresh_token', res.refresh);
        profileDetails();
      }
    } catch (err) {
      if (err?.response?.data?.detail) {
        setMessage(err.response.data.detail);
        posthog.capture('login_failure', {
          email: email,
          error_message: err?.response?.data?.detail || 'unknown_error'
        }
        );
      } else {
        setMessage('Something went wrong. Try again later.');
      }
    } 
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-6 bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-6 text-center">Log In</h2>

      <input
        type="email"
        placeholder="Email"
        className="w-full border px-3 py-2 rounded mb-4"
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
          setMessage('');
        }}
      />
      <input
        type="password"
        placeholder="Password"
        className="w-full border px-3 py-2 rounded mb-6"
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
          setMessage('');
        }}
      />

      <button
        onClick={handleLogin}
        disabled={loading}
        className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 disabled:opacity-50"
      >
        {loading ? 'Logging in...' : 'Log In'}
      </button>

      {message && <p className="mt-4 text-center text-sm text-red-700">{message}</p>}

      <p className="text-sm text-center mt-4">
        Don’t have an account?{' '}
        <button
          onClick={() => {
            onShowSignUp();
            posthog.capture('navigate_to_signup_from_login', {
              from: "login_page"
            });
          }}
          className="text-blue-600 hover:underline"
        >
          Sign Up
        </button>
      </p>
    </div>
  );
}
